module.exports = __webpack_public_path__ + "static/media/trump3.660d1a1b.jpg";